import { ThemeConstellation } from '@zillow/constellation';
import themeReset from './theme-reset';
import { breakpoints } from './breakpoints';
import { getCssValue, hexToAlpha, setCssVariable } from './utils';

export const zillowTheme = (theme: any) => {
  theme = {
    ...ThemeConstellation,
    breakpoints,
    constellation: themeReset,
  };

  const {
    ProgressStepper,
    Switch,
    Tabs,
    colors: { blue500 },
  } = theme.constellation;

  // HexToAlpha is used directly when setting the boxShadowRing value so explicit values are needed
  // During the theme generation process, the hexToAlpha function is not available so the initial value is undefined
  ProgressStepper.boxShadowRing = ProgressStepper.boxShadowRing.replace(
    'undefined',
    hexToAlpha(blue500, 0.2)
  );

  // These values are used internally when generating the url
  // for the assets and not a style rule so explicit values are needed
  Switch.iconColorOn = getCssValue(Switch.iconColorOn);
  Switch.iconColorOff = getCssValue(Switch.iconColorOff);

  // The background color is used directly in the TabsMixin in a call to hexToAlpha
  // which results in an error if a css variable is used so explicit values are needed
  Tabs.backgroundColor = getCssValue(Tabs.backgroundColor);

  return theme;
};

export const showingTimePlusTheme = (theme: any) => {
  setCssVariable('blue600', '#0e1c56');
  setCssVariable('blue500', '#3d6aad');
  setCssVariable('blue400', '#0d4599');
  setCssVariable('blue200', '#daf1ff');
  setCssVariable('blue100', '#e7f6ff');
  setCssVariable('yellow200', '#ff6619');
  setCssVariable('documentFieldNoteMarkerColor', 'var(--white)');

  return zillowTheme(theme);
};
